module.exports = "/_next/static/images/relatedPosts-5e82e7e0b1c98cfb55a23b4f27ff9c66.webp";